"use client";

import * as React from "react";
import tailwindConfig from "@oreme/tailwind-config";

const useTailwind = () => {
  return React.useMemo(() => tailwindConfig, []);
};

export { useTailwind };
